export default __webpack_public_path__ + "static/decrypt-9f2880ae8ddec6bb4f91fd8f40a9c75a.svg";